module.exports = __webpack_public_path__ + "static/media/zone4.c39f97f8.png";